// IncomeType Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get incomeTypeList from backend then update incomeTypeList in vuex store ***** //
export const updateIncomeTypeList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('income_types_index', { params: params })
    commit('updateIncomeTypeList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch IncomeType from backend ***** //
export const fetchIncomeTypeInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`income_types_show/${payload}`)
    commit('fetchIncomeTypeInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add IncomeType  ***** //
export const addIncomeType = async (ignored, payload = null) => {
  try {
    await Axios.post('income_types_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update IncomeType  info ***** //
export const updateIncomeTypeInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`income_types_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete IncomeType  ***** //
export const deleteIncomeType = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`income_types_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}

export const setFullIncomeTypesList = async ({ commit }) => {
  let incomeTypesList = []

  try {
    const result = await Axios.get('income_types_list')
    result.data.data.forEach(incomeType => {
      incomeTypesList.push({
        value: incomeType.income_type_id,
        text: incomeType.income_name
      })
    })
    commit('setFullIncomeTypesList', incomeTypesList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}
